// extracted by mini-css-extract-plugin
module.exports = {"applicationHeading":"Applications_applicationHeading__1eOFN","cycle":"Applications_cycle__1Wzkn"};